import React from "react";
import { ErrorMessage, Field } from "formik";
import { formatUnderscoreToSpace } from "../../utils/text-format";

export const FormTimeField = ({
  label = "textField",
  labelClassName = "",
  name = "textField",
  value = "",
  onChange = () => {},
  className = "",
  placeholder = "",
  type = "time",
  required,
  ...props
}) => {
  return (
    <div className="w-full">
      <Field name={name}>
        {({ field, meta }) => {
          const hasError = meta.touched && meta.error;

          return (
            <div className={`flex flex-col gap-2 ${className} w-full`}>
              {label && (
                <label
                  htmlFor={name}
                  className={`text-sm font-bold tracking-wide uppercase text-slate-700 ${labelClassName} ${
                    hasError ? "text-red-500" : ""
                  }`}
                >
                  {formatUnderscoreToSpace(label)}
                  {required && <span className="text-red-500 ms-0.5">*</span>}
                </label>
              )}

              <input
                {...field}
                {...props}
                id={name}
                name={name}
                type={type}
                placeholder={
                  placeholder ? formatUnderscoreToSpace(placeholder) : ""
                }
                required={required}
                className={`w-full px-4 py-3 text-base text-slate-700 bg-white border rounded-xl transition-all outline-none placeholder:text-slate-400 placeholder:text-base ${
                  hasError
                    ? "border-red-500 focus:border-red-500"
                    : "border-slate-200 focus:border-slate-400"
                }`}
              />

              <div className="min-h-[1.25rem] ps-1">
                <ErrorMessage name={name}>
                  {(msg) => (
                    <span className="text-xs font-medium text-red-500 block">
                      {msg}
                    </span>
                  )}
                </ErrorMessage>
              </div>
            </div>
          );
        }}
      </Field>
    </div>
  );
};

export const FormDateField = ({
  label = "textField",
  labelClassName = "",
  name = "textField",
  value = "",
  onChange = () => {},
  className = "",
  placeholder = "",
  type = "date",
  required,
  ...props
}) => {
  return (
    <div className="w-full">
      <Field name={name}>
        {({ field, meta }) => {
          const hasError = meta.touched && meta.error;

          return (
            <div className={`flex flex-col gap-2 ${className} w-full`}>
              {label && (
                <label
                  htmlFor={name}
                  className={`text-sm font-bold tracking-wide uppercase text-slate-700 ${labelClassName} ${
                    hasError ? "text-red-500" : ""
                  }`}
                >
                  {formatUnderscoreToSpace(label)}
                  {required && <span className="text-red-500 ms-0.5">*</span>}
                </label>
              )}

              <input
                {...field}
                {...props}
                id={name}
                name={name}
                type={type}
                placeholder={
                  placeholder ? formatUnderscoreToSpace(placeholder) : ""
                }
                required={required}
                className={`w-full px-4 py-3 text-base text-slate-700 bg-white border rounded-xl transition-all outline-none placeholder:text-slate-400 placeholder:text-base ${
                  hasError
                    ? "border-red-500 focus:border-red-500"
                    : "border-slate-200 focus:border-slate-400"
                }`}
              />

              <div className="min-h-[1.25rem] ps-1">
                <ErrorMessage name={name}>
                  {(msg) => (
                    <span className="text-xs font-medium text-red-500 block">
                      {msg}
                    </span>
                  )}
                </ErrorMessage>
              </div>
            </div>
          );
        }}
      </Field>
    </div>
  );
};
